import http from 'axios'

export default {
  getAllOffreAbonnement: () => {
    return http.get(`/web/v1/abonnement/offre`)
  },
  getAllOffreAbonnementByNumtiers: (numtiers) => {
    return http.get(`/web/v1/adherent/${numtiers}/abonnement/offre`)
  },
  updateOffreAbonnement: (offreAbonnement) => {
    return http.put(`/web/v1/abonnement/offre`, offreAbonnement)
  },
  createOffreAbonnementContenu: (offreID, contenuAbonnement) => {
    return http.post(`/web/v1/abonnement/offre/${offreID}/contenu`, contenuAbonnement)
  },
  updateOffreAbonnementContenu: (offreID, contenuAbonnement) => {
    return http.put(`/web/v1/abonnement/offre/${offreID}/contenu`, contenuAbonnement)
  },
  deleteOffreAbonnementContenu: (contenuAbonnementID) => {
    return http.delete(`/web/v1/abonnement/offre/contenu/${contenuAbonnementID}`)
  },
}
